// eslint-disable-next-line no-unused-vars
import React, { memo, useState } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import PromotionTemplates from 'Containers/PromotionTemplates/PromotionTemplates';

const StyledPromotionTemplates = styled.div`
  display: block;
`;

const PromotionTemplatesPage = memo(() => {
  const theme = useTheme();
  const { bodyAttributes } = Helmet.peek() || {};
  const { t } = useTranslation();
  const [templateTitle, setTemplateTitle] = useState('');

  let promotionTemplatesClassName = bodyAttributes?.class || '';
  if (!promotionTemplatesClassName.includes('PromotionTemplates')) {
    promotionTemplatesClassName += 'PromotionTemplates';
  }

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <title>{ templateTitle || t('common.page.promotion') }</title>
        <body className={ promotionTemplatesClassName } />
      </Helmet>
      <StyledPromotionTemplates theme={ theme }>
        <PromotionTemplates onTemplateTitleChange={ setTemplateTitle } />
      </StyledPromotionTemplates>
    </>
  );
});
PromotionTemplatesPage.displayName = 'PromotionTemplatesPage';

export default PromotionTemplatesPage;
